import { Injectable } from '@angular/core';
import { ReporteOperacionRepository } from './reporte-operacion.repository';
import { Observable } from 'rxjs';
import { getReporteAereoRequest, listarReporteEdiRequest, reporteClienteNaveRequest, reporteDepositoAlmacenRequest } from '../domain/reportes-operacion.request';
import { getReporteAereoResponse, listarNaveViajeeResponse, listarNaveViajeeResponseDTO, listarReporteEdiResponse, reporteClienteNaveResponse, reporteDepositoAlmacenResponse } from '../domain/reportes-operacion.response';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReporteOperacionService extends ReporteOperacionRepository {

  constructor(
    private readonly http: HttpClient
  ) {
    super()
  }

  override reporteDepositoAlmacen(request: reporteDepositoAlmacenRequest): Observable<reporteDepositoAlmacenResponse> {
    return this.http.post<reporteDepositoAlmacenResponse>(`${environment.PATH_API}/operaciones/getReporteDepositoAlmacen`, request)
  }

  override reporteClienteNave(request: reporteClienteNaveRequest): Observable<reporteClienteNaveResponse> {
    return this.http.post<reporteClienteNaveResponse>(`${environment.PATH_API}/operaciones/getClientPerShip`, request)
  }

  override ListarNaveViaje(): Observable<listarNaveViajeeResponse> {
    return this.http.post<listarNaveViajeeResponse>(`${environment.PATH_API}/operaciones/getShipTrip`, null)
  }

  override listarReporteEdi(request: listarReporteEdiRequest): Observable<listarReporteEdiResponse> {
    return this.http.post<listarReporteEdiResponse>(`${environment.PATH_API}/operaciones/listarlogEDI`, request)
  }

  override reporteAereoGp(request: getReporteAereoRequest): Observable<getReporteAereoResponse> {
    return this.http.post<getReporteAereoResponse>(`${environment.PATH_API}/operaciones/getReporteAereoGp`, request)
  }

}
